import F from "@babel/runtime/helpers/esm/objectSpread2";
import T from "@babel/runtime/helpers/esm/classCallCheck";
import L from "@babel/runtime/helpers/esm/createClass";
import v from "@babel/runtime/helpers/esm/assertThisInitialized";
import E from "@babel/runtime/helpers/esm/inherits";
import M from "@babel/runtime/helpers/esm/createSuper";
import d from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as B } from "@semcore/utils/lib/core/index";
import D, { sstyled as j, assignProps as A, Component as V } from "@semcore/core";
import l from "react";
import { Box as h } from "@semcore/flex-box";
import f from "@semcore/input";
import z from "@semcore/icon/Check/m";
import R from "@semcore/icon/Close/m";
var H = (
  /*__reshadow_css_start__*/
  (B.insert(
    /*__inner_css_start__*/
    '.___SColorPickerPopper_15lm4_gg_{max-width:calc(var(--intergalactic-spacing-4x, 16px)*2 + 28px*6 + 4px*6);padding:var(--intergalactic-spacing-4x, 16px)}.___SItemContainer_15lm4_gg_{position:relative;display:flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:50%;border:1px solid transparent;outline:0;cursor:pointer}@media (hover:hover){.___SItemContainer_15lm4_gg_:hover{border:1px solid var(--intergalactic-border-secondary, #e0e1e9)}}.___SItemContainer_15lm4_gg_::after{content:"";position:absolute;width:22px;height:22px;border-radius:50%;box-shadow:inset 0 0 1px var(--intergalactic-border-secondary, #e0e1e9);background:var(--value_15lm4)}@media (hover:hover){.___SItemContainer_15lm4_gg_:hover>.___SCloseIcon_15lm4_gg_{opacity:1}}.___SItemContainer_15lm4_gg_.__keyboardFocused_15lm4_gg_{box-shadow:var(--intergalactic-keyboard-focus, 0px 0px 0px 3px rgba(0, 143, 248, 0.5))}.___SItemContainer_15lm4_gg_.__selected_15lm4_gg_{border:1px solid var(--intergalactic-border-info-active, #006dca)}.___SItemContainer_15lm4_gg_.__displayLabel_15lm4_gg_::after{background:var(--value_15lm4);opacity:.15}.___SItemContainer_15lm4_gg_:not(.__value_15lm4_gg_)::after{border:.9px solid var(--intergalactic-border-secondary, #e0e1e9)}.___SColorsContainer_15lm4_gg_,.___SColors_15lm4_gg_{display:flex;flex-wrap:wrap;align-items:center;gap:var(--intergalactic-spacing-1x, 4px)}.___SPaletteManager_15lm4_gg_{justify-content:space-between;margin-top:var(--intergalactic-spacing-3x, 12px);margin-left:calc(var(--intergalactic-spacing-1x, 4px) - 1px)}.___SInputContainer_15lm4_gg_,.___SPaletteManager_15lm4_gg_,.___SPlusButton_15lm4_gg_{display:flex;align-items:center}.___SPlusButton_15lm4_gg_{justify-content:center;width:28px;height:28px;border-radius:50%;cursor:pointer}@media (hover:hover){.___SPlusButton_15lm4_gg_:hover{background-color:var(--intergalactic-bg-secondary-neutral-hover, #e0e1e9)}}.___SDefaultTrigger_15lm4_gg_{display:inline-flex;align-items:center;outline:0;cursor:pointer;border:0;background:0 0;padding:0}.___SDefaultTrigger_15lm4_gg_.__keyboardFocused_15lm4_gg_{box-shadow:var(--intergalactic-keyboard-focus, 0px 0px 0px 3px rgba(0, 143, 248, 0.5))}.___STriggerCircle_15lm4_gg_{position:relative;width:16px;height:16px;margin-right:calc(var(--intergalactic-spacing-1x, 4px) + 1px);border-radius:50%;background-color:var(--data-value_15lm4);border:1px solid transparent}.___STriggerCircle_15lm4_gg_:not([data-value]){border:1px solid var(--intergalactic-border-secondary, #e0e1e9)}.___STriggerCircleLine_15lm4_gg_{position:absolute;top:1px;left:1px}.___SCloseIcon_15lm4_gg_{position:absolute;top:0;right:0;display:flex;align-items:center;justify-content:center;width:12px;height:12px;border-radius:50%;background-color:var(--intergalactic-bg-primary-neutral, #ffffff);opacity:0;z-index:1}.___SLine_15lm4_gg_{position:absolute}.___SLabel_15lm4_gg_{z-index:1;color:var(--data-value_15lm4);font-size:calc(var(--intergalactic-fs-100, 12px) + 1px);font-weight:var(--intergalactic-bold, 700)}.___SItemColor_15lm4_gg_{width:20px;height:20px;border-radius:50%;border:1px solid var(--intergalactic-border-secondary, #e0e1e9);background:var(--data-value_15lm4)}.___SClearConfirm_15lm4_gg_.__hidden_15lm4_gg_,.___SConfirmColor_15lm4_gg_.__hidden_15lm4_gg_{display:none}',
    "15lm4_gg_"
  ), {
    __SColorPickerPopper: "___SColorPickerPopper_15lm4_gg_",
    __SItemContainer: "___SItemContainer_15lm4_gg_",
    __SCloseIcon: "___SCloseIcon_15lm4_gg_",
    _keyboardFocused: "__keyboardFocused_15lm4_gg_",
    _selected: "__selected_15lm4_gg_",
    __SColorsContainer: "___SColorsContainer_15lm4_gg_",
    __SColors: "___SColors_15lm4_gg_",
    __SPaletteManager: "___SPaletteManager_15lm4_gg_",
    __SInputContainer: "___SInputContainer_15lm4_gg_",
    __SDefaultTrigger: "___SDefaultTrigger_15lm4_gg_",
    __STriggerCircle: "___STriggerCircle_15lm4_gg_",
    "--data-value": "--data-value_15lm4",
    __STriggerCircleLine: "___STriggerCircleLine_15lm4_gg_",
    __SLine: "___SLine_15lm4_gg_",
    __SLabel: "___SLabel_15lm4_gg_",
    __SItemColor: "___SItemColor_15lm4_gg_",
    __SConfirmColor: "___SConfirmColor_15lm4_gg_",
    _hidden: "__hidden_15lm4_gg_",
    __SClearConfirm: "___SClearConfirm_15lm4_gg_",
    "--value": "--value_15lm4",
    _displayLabel: "__displayLabel_15lm4_gg_",
    _value: "__value_15lm4_gg_",
    __SPlusButton: "___SPlusButton_15lm4_gg_"
  })
);
function K(o) {
  if (o[0] !== "#" && o.length === 7) return !1;
  var i = /^#([0-9a-f]{3,4}){1,2}$/i;
  return o[0] === "#" ? i.test(o) : i.test("#".concat(o));
}
function N(o, i) {
  var g = this, e;
  return function() {
    for (var c = arguments.length, r = new Array(c), _ = 0; _ < c; _++)
      r[_] = arguments[_];
    clearTimeout(e), e = setTimeout(function() {
      o.apply(g, r);
    }, i);
  };
}
var C = /* @__PURE__ */ function(o) {
  E(g, o);
  var i = M(g);
  function g() {
    var e;
    T(this, g);
    for (var c = arguments.length, r = new Array(c), _ = 0; _ < c; _++)
      r[_] = arguments[_];
    return e = i.call.apply(i, [this].concat(r)), d(v(e), "handlerAdd", function(a) {
      var p = e.asProps, t = p.value, S = p.state;
      if (t.length !== 0 && S === "normal") {
        if (t[0] === "#") {
          var m, s;
          (m = e.asProps) === null || m === void 0 || (s = m.onAdd) === null || s === void 0 || s.call(m, t.toLowerCase(), a);
        } else {
          var n, u;
          (n = e.asProps) === null || n === void 0 || (u = n.onAdd) === null || u === void 0 || u.call(n, "#".concat(t.toLowerCase()), a);
        }
        e.handlers.value("", a);
      }
    }), d(v(e), "handlerCancel", function(a) {
      e.handlers.value("", a);
    }), d(v(e), "handlerChange", N(function(a) {
      a.length !== 0 ? K(a) ? e.handlers.state("normal") : e.handlers.state("invalid") : e.handlers.state("normal");
    }, 300)), d(v(e), "handlekeyDown", function(a) {
      a.key === "Enter" && (a.preventDefault(), e.handlerAdd(a));
    }), e;
  }
  return L(g, [{
    key: "uncontrolledProps",
    value: function() {
      return {
        value: "",
        state: null
      };
    }
  }, {
    key: "render",
    value: function() {
      var c = this.asProps, r, _ = this.asProps, a = _.styles, p = _.state, t = _.value, S = _.onFocus, m = _.onBlur, s = _.focus, n = _.getI18nText, u = h, x = f.Value, b = "div", y = "div", I = f.Addon, w = f.Addon, k = h, P = (t == null ? void 0 : t[0]) === "#" ? t : t ? "#".concat(t) : null;
      return r = j(a), /* @__PURE__ */ l.createElement(u, r.cn("SPaletteManager", {}), /* @__PURE__ */ l.createElement(k, r.cn("SItemColor", {
        "data-value": P
      })), /* @__PURE__ */ l.createElement(y, r.cn("SInputContainer", {}), /* @__PURE__ */ l.createElement("span", r.cn("span", {
        "aria-hidden": "true"
      }), "#"), /* @__PURE__ */ l.createElement(b, r.cn("SInput", {}), /* @__PURE__ */ l.createElement(f, r.cn("Input", {
        ml: 1,
        w: 135,
        state: p,
        onKeyDown: this.handlekeyDown
      }), /* @__PURE__ */ l.createElement(x, r.cn("SInputValue", F({}, A({
        placeholder: "FFFFFF",
        "aria-label": n("colorField"),
        onChange: this.handlerChange,
        maxLength: 7,
        onFocus: S,
        onBlur: m
      }, c)))), /* @__PURE__ */ l.createElement(I, r.cn("SConfirmColor", {
        "aria-hidden": "true",
        "aria-label": n("colorFieldConfirm"),
        role: "button",
        interactive: !0,
        onClick: this.handlerAdd,
        pr: "4px",
        hidden: !s
      }), /* @__PURE__ */ l.createElement(z, r.cn("CheckM", {
        color: "green-300"
      }))), /* @__PURE__ */ l.createElement(w, r.cn("SClearConfirm", {
        "aria-hidden": "true",
        "aria-label": n("colorFieldClear"),
        role: "button",
        interactive: !0,
        onClick: this.handlerCancel,
        pl: "4px",
        hidden: !s
      }), /* @__PURE__ */ l.createElement(R, r.cn("CloseM", {
        color: "gray-300"
      })))))));
    }
  }]), g;
}(V);
d(C, "displayName", "InputColor");
d(C, "style", H);
d(C, "defaultProps", {
  defaultValue: "",
  defaultState: "normal"
});
var ae = D(C);
export {
  ae as InputColor
};
